import React from "react";
import { useSearchParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiAlertOutline } from "@mdi/js";

import "../pages/header.css";
import "../pages/Uploads.css";

import logotypeDark from "../assets/dance_locale_3-200h.png";
import danceLocaleIcon from "../assets/logo_fox_map_pin_v4-600h.png";

/**
 * Public result page shown after a successful self-serve account deletion
 * request (the user is logged out at this point). Mirrors CancelDeletion.js.
 * The scheduled deletion date arrives as ?date=<ISO> from Settings.
 */
const DeletionRequested = () => {
    const [searchParams] = useSearchParams();
    const dateParam = searchParams.get("date");
    const parsedDate = dateParam ? new Date(dateParam) : null;
    // The preposition lives in the date branch, not the sentence — otherwise the
    // no-date fallback renders "scheduled for permanent deletion on in 30 days".
    const deletionWhenText =
        parsedDate && !isNaN(parsedDate.getTime())
            ? `on ${parsedDate.toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}`
            : "in 30 days";

    return (
        <div className="dashboard-container branded-bg">
            {/* Header */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="Dance Locale" src={logotypeDark} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                            Home
                        </a>
                        <a href="/faq" className="home-text11" style={{ cursor: "pointer", textDecoration: "none" }}>
                            FAQ
                        </a>
                    </div>
                </header>
            </div>

            {/* Main Content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper" style={{ maxWidth: "500px" }}>
                    <div className="dashboard-header-card">
                        <div style={{ marginBottom: "var(--dl-layout-space-doubleunit)" }}>
                            {/* display:block + margin auto centres reliably; the previous
                                textAlign on the wrapper was not taking effect. */}
                            <img
                                src={danceLocaleIcon}
                                alt="Dance Locale"
                                style={{ width: "60px", height: "60px", display: "block", margin: "0 auto" }}
                            />
                        </div>

                        <h1 className="admin-console-title" style={{ color: "var(--dl-color-danger)" }}>
                            Deletion Scheduled
                        </h1>
                        <p className="admin-console-description">
                            {`Your account is scheduled for permanent deletion ${deletionWhenText}. You have been logged out.`}
                        </p>

                        <div
                            className="admin-console-instructions"
                            style={{ backgroundColor: "var(--dl-color-yellow-50)", borderColor: "var(--dl-color-yellow-100)" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    fontWeight: "600",
                                    color: "var(--dl-color-status-amber)",
                                    marginBottom: "var(--dl-layout-space-halfunit)",
                                    fontSize: "14px",
                                }}>
                                <Icon path={mdiAlertOutline} size={0.9} style={{ flexShrink: 0 }} />
                                Changed your mind?
                            </div>
                            <div style={{ color: "var(--dl-color-status-amber)", fontSize: "14px", lineHeight: "1.4" }}>
                                You can cancel the delete request at any time before that date, either by logging back
                                in, or by using the link in the email we just sent you.
                            </div>
                        </div>

                        {/* Primary action is the recovery path, not "go home" — the header
                            already covers navigation. Logging in during the grace period
                            surfaces the restore affordance (auth.service login returns 423
                            with canRestore), which is one of the two documented recovery
                            routes; the emailed cancel link is the other. */}
                        <a
                            href="/login"
                            className="btn-purple"
                            style={{
                                width: "100%",
                                textDecoration: "none",
                                display: "block",
                                textAlign: "center",
                                boxSizing: "border-box",
                                /* Collapses with the amber box's 16px bottom margin to 25.6px —
                                   the CTA needs the widest gap in the card, not the narrowest. */
                                marginTop: "var(--dl-layout-space-doubleunit)",
                                padding: "14px 16px",
                                fontSize: "16px",
                            }}>
                            Log in to cancel deletion
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeletionRequested;
